import React, { useState ,
    useEffect } from "react";
  import {
    Container,
    Row,
    Col,
    Table,
    Input,
    Collapse,
    Card,
    Form,
    FormGroup,
    Label,
    CardBody
  } from "reactstrap";
  
  import { Link } from "react-router-dom";
  import SweetAlert from "react-bootstrap-sweetalert";
  //Import Breadcrumb
  import Breadcrumbs from "../../components/Common/Breadcrumb";
  import  { useHistory } from  'react-router-dom'
  import moment from 'moment'
  //Import Images
  import img1 from "../../assets/images/product/img-1.png";
  import img6 from "../../assets/images/product/img-6.png";
  import  Spinner  from 'react-spinkit'
  import Backdrop from '@material-ui/core/Backdrop';
  import '../../NumberInput.css'
  import axios from "../../axios"
  import { makeStyles } from '@material-ui/core/styles';
  import Select from "react-select";
  import numeral from "numeral";
  import toastr from "toastr"
  const orderSummary = [
    {
      id: 1,
      img: img1,
      productTitle: "Nike N012 Running Shoes",
      price: 260,
      qty: 2,
    },
    { id: 2, img: img6, productTitle: "Adidas Running Shoes", price: 260, qty: 1 },
  ];
  const useStyles = makeStyles((theme) => ({
      backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
    }));
  const EcommerceCheckout = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [Purchasesavess, setPurchasesavess] = useState(false)
    const [dailoa1, setdailoa1] = useState(false)
    const toggle = () => setIsOpen(!isOpen);
    const history = useHistory()
    const [isOpenShippinginfo, setIsOpenShippinginfo] = useState(false);
  
    const toggleShippinginfo = () => setIsOpenShippinginfo(!isOpenShippinginfo);
    const [allcartproducts, setallcartproducts] = useState([])
    const [isOpenPaymentinfo, setIsOpenPaymentinfo] = useState(false);
    const classes = useStyles();
    const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
    const [purchseid, setpurchseid] = useState('')
    const togglePaymentinfo = () => setIsOpenPaymentinfo(!isOpenPaymentinfo);
    const [allsupplierinfo, setallsupplierinfo] = useState([])
    const [suppliid, setsuppliid] = useState('')
    const [onsupplierinfo, setonsupplierinfo] = useState([])
    const [emailid, setemailid] = useState('')
    const [phone, setphone] = useState('')
    const [city, setcity] = useState('')
    const [zipcode, setzipcode] = useState('')
    const [country, setcountry] = useState('')
    const [address, setaddress] = useState('')
    const [supperror, setsupperror] = useState(false)
    var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
   /// const [imageurl, setimageurl] = useState('http://localhost/Balaji_services/Public/')
    const [deliverydate, setdeliverydate] = useState(new Date())
    const [orderdate, setorderdate] = useState(new Date())
    const [mailcontent, setmailcontent] = useState([])
    const [Mailtoggle, setMailtoggle] = useState(false)
    const [porefno, setporefno] = useState('')
    const [porefnoerror, setporefnoerror] = useState(false)
    const [alltransportcollection, setalltransportcollection] = useState([])
    const [transpoid, settranspoid] = useState('')
    
    useEffect(() => {
      let cartproducts = []
      let productofcart = JSON.parse(localStorage.getItem('Salescart'))
      //cartproducts.push()
  setallcartproducts(productofcart)
    }, [])
    const Mailtoogle = () => {
      if (Mailtoggle) {
        setMailtoggle(false);
        //setccmails('')
        //setInvoice(null);
      } else {
        setMailtoggle(true);
       // setccmails('')
      }
    };
  
    const Createpurchaseorder = async() => {
      if(porefno.length !=0){
      
    
     const create  = await axios.instance.post(`/Insertsalesorderhdr`, {
    
        OpType:'New',
        Order_No:0,
        Order_Date:moment(orderdate).format('YYYY-MM-DD'),
        Delivery_Date:deliverydate,
        Company_Id:localStorage.getItem('CompanyId'),
        Customer_Id:suppliid,
        Remarks:"",
        Total_Amount:parseFloat(localStorage.getItem('Totalsumamounts1')),
        Discount_Amount:0,
        Vat_Amount: localStorage.getItem('statecode') === '33'  ? parseFloat(localStorage.getItem('Totaligstvalue1'))/2 :0,                                
        CST_Amount:0,
        Net_Amount:parseFloat(localStorage.getItem('Totalsumamounts1'))+parseFloat(localStorage.getItem('Totaligstvalue1')),
        Branch_Id:7,
        CBranch_Id:7,
        Dealivery_At:deliverydate,
        Created_by:localStorage.getItem('UserId'),
        Created_on:new Date(),
        APPROVED: 'Y',
        Cust_PO_Ref:porefno === '' ? 0 : porefno,
        Cust_PO_Ref_dt:new Date,          
        Type:"",
        SalesMan_Id:0,
        prefix_order_no:0,
        CurrencyId:1,
        Approve:"Y",
        ApproveDate:new Date(),
        ApprovedBy:localStorage.getItem('UserId'),
        DutyAmt:1,
        So_TransType:"Local",
        SoInvoiceType:"Local",
        PIRef_No:0,
        PIRef_Date:new Date(),          
        LPO_Id:1,
        StateId:localStorage.getItem('stateid'),
        PlaceofSupply:"Tamil Nadu",
        StateCode:localStorage.getItem('statecode'),
        SGSTAmt: localStorage.getItem('statecode') === '33'  ? parseFloat(localStorage.getItem('Totaligstvalue1'))/2 :0,
        IGSTAmt:localStorage.getItem('statecode') === '33'  ? 0: parseFloat(localStorage.getItem('Totaligstvalue1')),
        RoundOff:"+",RoundOffAmt:0,PORefId:1,warehouse_id:1,Transport_id:transpoid
     
     },{ headers: {'Authorization':tokent,
     'Content-Type': 'application/json',
    
     },method:"post"}).then((res) => {
     //////console.log('header', res.data)
      for(const data of res.data) {
       localStorage.setItem('Salid', data.Order_Id)
      setpurchseid(data.Order_Id)
      
      }
  
      }).then(async() => {
       // setdailoa1(true)
        if(suppliid.length !=0){
  
      
        const  details = localStorage.getItem('Salescart')
        const Orderid =   localStorage.getItem('Salid')
        let product =  JSON.parse(details)
        for(const data of product){
          const productcoll = Object.assign({
            Order_Id:localStorage.getItem('Salid'),
            Product_Id:data.Product_Details_Id,
            UOM_Id:data.UOM_Id,
            Order_Qty:data.Order_Qty,
            Rate:data.Rate,
            CST_Percentage:0,
            VAT_Percentage:localStorage.getItem('statecode') === '33' ? data.VAT_Percentage:0,
            Discount:0,
            Amount:data.Rate * data.Order_Qty
            ,PoSlNo:0,        
        OtherDesc:0,
        TaxId:data.TaxId,
        PriUOM_Id:data.UOM_Id,
        PriOrder_Quantity:data.Order_Qty,
        PriRate:data.Rate,
        ConQty:data.Order_Qty,
        Act_UOM:data.UOM_Id,
        Act_Rate:data.Rate,
        Act_Qty:data.Order_Qty,
        DisAmt:0,
        DutyPer:0,
        Duty_Id:0,
        Lpo_Id:0,
        Sec_UomId:data.UOM_Id,    
        GSTPer:data.GSTPer,
        SGSTId: localStorage.getItem('statecode') === '33'  ? data.SGSTId :0,
        SGSTPer:localStorage.getItem('statecode') === '33' ? data.SGSTPer:0,
        IGSTId:localStorage.getItem('statecode') === '33' ? 0: data.IGSTId,
        IGSTPer:localStorage.getItem('statecode') === '33' ? 0:data.IGSTPer
          }
            , {Order_Id: parseInt(Orderid),OpType:'New'})
      const Dtl  =  await axios.instance.post(`/Insertsalesorderdtl`,productcoll
      
      
      ,{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
       
        },method:"post"}).then((res) => {
          //////console.log( 'details', res.data)
  
        
          localStorage.setItem('TotalQty1',0);
          localStorage.setItem('taxvalue1',0);
          localStorage.setItem('Totalsumamounts1',0)
          localStorage.removeItem('Salescart')
          localStorage.setItem('Totaligstvalue1',0)
         
           localStorage.removeItem('totalsalesrate',0)
        localStorage.setItem('Salescartcount',0)
      
      })
     
      setTimeout(() => {
        setdailoa1(false)
        setsupperror(false)
      }, 2000);
    
      setPurchasesavess(true)
  setTimeout(() => {
    history.push('/Salesorder')
    setsupperror(false)
  }, 3000);
    
      }
      SendMail()
    }else{
      if(suppliid.length === 0){
        setsupperror(true)
         }
         setTimeout(() => {
          setsupperror(false)
         }, 2000);
         
    }
    
    })
 
  }else{
    if(porefno.length ===0){
setporefnoerror(true)
    }
    setTimeout(() => {
      setporefnoerror(false)
     }, 2000);
   
  }

    }
  useEffect(() => {
    
  
    Getallsuppliervalue()
    Getalltransport()
  }, [])
 
    const Getallsuppliervalue = async() => {
      const get= await axios.instance.get(`/Getallcustomer/${localStorage.getItem('CompanyId')}`,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        
        const data  =res.data
        const options = data.map(b => ( {
        'label' : b.Customer_Name,
        'value' : b.Customer_Id
        }))
        options.push({'label' : 'All' , 'value' : '0'})
  setallsupplierinfo(options)
      })
      }
      const Getalltransport = async() => {
        const get= await axios.instance.get(`/Getalltransemaster`,{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          
          const data  =res.data
          const options = data.map(b => ( {
          'label' : b.Transport_Name,
          'value' : b.Transport_Id
          }))
    
    setalltransportcollection(options)
        })
        }
    
  
      const Getonesupplier = async(id) => {
        const get= await axios.instance.get(`/Getonecustomer/${id}`,{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          
        
    
    setonsupplierinfo(res.data)
    for(const data of res.data){
  setemailid(data.EmailId)
  setphone(data.Phone)
  setcountry(data.Country)
  setaddress(data.Address1)
  setcity(data.City)
  setzipcode(data.Zip_Code)
  localStorage.setItem('stateid', data.StateId)
localStorage.setItem('statecode',data.StateCode)
    }
        })
        }
      const getbuyers =(id) => {
        setsuppliid(id)
        Getonesupplier(id)
      }
      const gettranid= (id) => {
settranspoid(id)
      }
      const GetMailInfo  =  async(Content) => {
        setmailcontent(Content)
        Mailtoogle()
     
     
       }
       const SendMail  = async() => {
        ////////console.log(mailcontent.Buyer)
      
          const mail =  await axios.instance.post(`/salesmail` , 
        {
      username :localStorage.getItem('EmailId'),
      tomail:emailid,
      sub:"Sales Order",
     
      host:localStorage.getItem('SMTPServer'),
      port:localStorage.getItem('smtpport'),
    // --Factorycontactperson :"test",
      password:localStorage.getItem('mailpassword'),
      Companyname:localStorage.getItem('companyName'),
      loginname:localStorage.getItem('UserName'),
       CcMail : localStorage.getItem('CCEmailId')
      
    },
        
        
       { headers: {'Authorization':tokent,
         'Content-Type': 'application/json'}}).then((res) => {
        if(res.status === 200) {
            toastr.success('Mail Sent Successfully', 'Sales Order')
        }else {
          toastr.error('Something went wrong ', 'Sales Order')
        }
       
         })
         Mailtoogle()
        PrintDownload()
      }  














      
      const PrintDownload =async() => {
        // --const Arg = id.InvoiceId
      // setdailoa1(true)
     // //////console.log('pritn',id)
      
      const PrintInvoice = await axios.instance.get(`/Salesprint/${localStorage.getItem('Salid')}`).then(async() => {
    
      })
      
      
      }

      const productredirect =(id) => {
        history.push(`/Sales-order-detail/${id}`)
      }
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Purchase Order" breadcrumbItem="Checkout" />
  
            <div className="checkout-tabs">
              <Row className="mb-3">
                <Col xl="8">
                  <div className="custom-accordion">
                    <Card>
                      <Link onClick={toggle} className="text-dark" to="#">
                        <div className="p-4">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-3">
                              <i className="uil uil-receipt text-primary h2"></i>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <h5 className="font-size-16 mb-1">Billing Info</h5>
                              <p className="text-muted text-truncate mb-0"></p>
                            </div>
                            <div className="flex-shrink-0">
                              <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                            </div>
                          </div>
                        </div>
                      </Link>
                      <Collapse isOpen={isOpen}>
                        <div className="p-4 border-top">
                          <Form>
                            <div>
                              <Row>
                                <Col lg={4}>
                                  <div className="mb-3 mb-4">
                                    <Label
                                      htmlFor="billing-name"
  
                                      className="form-label"
                                    >
                                      Customer Name
                                    </Label>
                                    <Select
                                  options={allsupplierinfo}
                       classNamePrefix="select2-search-disable"
                       onChange={(value)=> getbuyers(value.value)}
                     />
                                  </div>
                                  {supperror ? <p  className="error">Please Select Customer </p> :  null}
  
                                </Col>
                                <Col lg={4}>
                                  <div className="mb-3 mb-4">
                                    <Label
                                      htmlFor="billing-email-address"
  
                                      className="form-label"
                                    >
                                      Email Address
                                    </Label>
                                    <Input
                                      type="email"
                                      className="form-control"
                                      id="billing-email-address"
                                      placeholder="Enter your email"
                                      value={emailid}
                                      disabled
                                    />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="mb-3 mb-4">
                                    <Label
                                      htmlFor="billing-phone"
  
                                      className="form-label"
                                    >
                                      Phone
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="billing-phone"
                                      placeholder="Enter your Phone no."
                                      value={phone}
                                      disabled
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <div className="mb-4">
                                <Label
                                  htmlFor="billing-address"
                                  className="form-label"
                                >
                                  Address
                                </Label>
                                <textarea
                                  className="form-control"
                                  id="billing-address"
                                  rows="3"
                                  disabled
                                  value={address}
                                  placeholder="Enter full address"
                                />
                              </div>
                              <Row>
                                <Col lg={4}>
                                  <FormGroup className="mb-4 mb-lg-0">
                                    <Label className="form-label">
                                      Country
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      disabled
                                      value={country}
                                    />
  
                                  </FormGroup>
                                </Col>
                                <Col lg={4}>
                                  <div className="mb-4 mb-lg-0">
                                    <Label className="form-label" htmlFor="billing-city">City</Label>
                                    <Input disabled type="text" value={city} className="form-control" id="billing-city" placeholder="Enter City" />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="mb-4 mb-lg-0">
                                    <Label className="form-label" htmlFor="zip-code">ZipCode</Label>
                                    <Input disabled type="text" value={zipcode} className="form-control" id="zip-code" placeholder="Enter Postal code" />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                <div className="mb-4 mb-lg-0">
                                  <Label className="form-label" htmlFor="zip-code">Delivery Date</Label>
                                  <Input  type="date" value={moment (deliverydate).format('YYYY-MM-DD')} onChange={(e)=>setdeliverydate(e.target.value)} className="form-control" id="zip-code" placeholder="Enter Postal code" />
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div className="mb-4 mb-lg-0">
                                  <Label className="form-label" htmlFor="zip-code">Po/Order RefNo</Label>
                                  <Input type="number" value={porefno} onChange={(e)=>setporefno(e.target.value)} className="form-control" id="zip-code"  />
                                </div>
                                {porefnoerror ? <p  className="error">Please Enter  Po Reference </p> :  null}

                              </Col>
                              <Col lg={4}>
                                  <div className="mb-3 mb-4">
                                    <Label
                                      htmlFor="billing-name"
  
                                      className="form-label"
                                    >
                                      Transport Name
                                    </Label>
                                    <Select
                                  options={alltransportcollection}
                       classNamePrefix="select2-search-disable"
                       onChange={(value)=> gettranid(value.value)}
                     />
                                  </div>
                                 
  
                                </Col>
                              </Row>
                            </div>
                          </Form>
                        </div>
                      </Collapse>
                    </Card>
                
                  </div>
                  <Row>
                    <Col>
                      <Link to="/Purchaseorder" className="btn btn-link text-muted">
                        <i className="uil uil-arrow-left me-1"></i> Continue Shopping
                      </Link>
                    </Col>
                    <Col>
                      <div className="text-sm-end mt-2 mt-sm-0">
                        <Link to="#" className="btn btn-success" onClick={Createpurchaseorder}>
                          <i className="uil uil-shopping-cart-alt me-1"></i> Proceed </Link>
                      </div>
                    </Col>
                  </Row>
                </Col>
  
                <Col xl="4">
  
                  <Card className="checkout-order-summary">
                    <CardBody>
                      <div className="p-3 bg-light mb-4">
                        <h5 className="font-size-16 mb-0">Order Summary <span className="float-end ml-2"></span></h5>
                      </div>
  
                      <div className="table-responsive">
                        <Table className="table-centered mb-0 table-nowrap">
                          <thead className="thead-light">
                            <tr>
                              <th className="border-top-0" style={{ width: "110px" }} scope="col">Product</th>
                              <th className="border-top-0" scope="col">Product Description</th>
                           
                            </tr>
                          </thead>
                          {allcartproducts.map((data, index) => (
                          <tbody  key ={data.Product_Details_Id}>
                           
                              <tr key={data.Product_Details_Id}>
                                <th scope="row">
                                <img src={`${data.Imagepath}`} 
   style={{width:'50px', height:'50px'}}
    alt="" className="img-fluid mx-auto d-block"
    onError={({ currentTarget }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src=imageDefault;
    }}
     
    /> 
                                </th>
                                <td>
                                  <h5 className="font-size-14 text-truncate">
                                    <Link
                                      to="#"
                                      className="text-dark"
                                      onClick={()=>productredirect(data.Product_Details_Id)}
                                    >
                                      {data.Product_Details_Description}{" "}
                                    </Link>
                                  </h5>
                                  <p className="text-muted mb-0">
                                
                                  </p>
                                </td>
                                <td>
                               
                                </td>
                              </tr>
                        
                            <tr>
                              <td colSpan="2">
                                <h6 className="font-size-14 m-0">
                                  Gross Amount:
                                </h6>
                              </td>
                              <td colSpan="2" className="text-end">₹ {numeral(data.Rate* data.Order_Qty).format('0,0.00')}</td>
                            </tr>
                        
  
                            <tr>
                              <td colSpan="2">
                                <h5 className="font-size-14 m-0">GST Amount:</h5>
                              </td>

                              
                              <td>
                              <td  colSpan="2">₹ {numeral((data.Order_Qty * (data.Rate)/(100 + data.GSTPer)*100) * (data.GSTPer)/100).format('0,0.00')}</td>
                              </td>
                            </tr>
  
                            <tr className="bg-light">
                              <td colSpan="2">
                                <h5 className="font-size-14 m-0">Total:</h5>
                              </td>
                              <td className="text-end">
                            <span className="fw-bold"> ₹{numeral(parseFloat(((data.Order_Qty * (data.Rate)/(100 + data.GSTPer)*100) * (data.GSTPer)/100)) + parseFloat((data.Rate* data.Order_Qty))).format('0,0.00')}</span>
                          </td>
                            </tr>
                          </tbody>
                            ))}
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                  
                </Col>
              
              </Row>
            </div>
          </Container>
        </div>
        {dailoa1 ? (
        <Backdrop  open={dailoa1} className={classes.backdrop} >
        <Spinner name="ball-spin-fade-loader"  color='#fafafa' />
  
       </Backdrop>
        ): null}
        {Purchasesavess ? (
                      <SweetAlert
                        title="Sales Order Added Successfully"
                        timeout={2000}
                        style={{
                          position: "absolute",
                           justifyContent:'center',
                           alignItems:'center'
                        }}
                        showCloseButton={false}
                        showConfirm={false}
                        success
                        onConfirm={() => {
                          setPurchasesavess(false);
                        }}
                      ></SweetAlert>
                    ) : null}
      </React.Fragment>
    );
  };
  
  export default EcommerceCheckout;
  